import { SelectOption } from '@kanda-libs/ks-component-ts';

import { YOUR_INFO_CLASS_NAMES } from '../../../constants';

export const PROPS = {
  title: {
    text: 'Employment Information',
    className: YOUR_INFO_CLASS_NAMES.title,
  },
  description: {
    text: 'We need a few more details about your employment history',
    className: 'text-style-g text-neutral-700 mb-6 -mt-4',
  },
  grossAnnualIncome: {
    type: 'price',
    icon: 'pound',
    iconVariant: 'dark',
    symbol: '',
    label: 'Gross Annual Income',
    placeholder: 'Your gross annual income/salary',
    validation: {
      min: { value: 1000000, message: 'Amount must be great than £10,000' },
      required: {
        value: true,
        message: 'You must provide your gross annual salary',
      },
    },
  },
  householdAnnualIncome: {
    type: 'price',
    icon: 'pound',
    iconVariant: 'dark',
    symbol: '',
    label: 'Household Annual Income',
    placeholder: 'Your household annual income',
  },
};

export const EMPLOYMENT_STATUS_FIELD_NAME =
  'credit.employment_details.employment_status';

export const ERROR_PROPS = {
  label: {
    required: 'You must provide the date you became $STATUS',
    inPast: 'The date provided must be in the past',
  },
  className: 'text-style-h text-red-200 -mt-4 mb-6',
};

export const TITLES = {
  EMPLOYED: 'When did your employment start?',
  SELF_EMPLOYED: 'When did you become self employed?',
  NOT_EMPLOYED: 'When did you become not employment?',
  RETIRED: 'When did you retire?',
};

export const MONTHS_OPTIONS: SelectOption[] = [
  {
    name: 'Jan',
    value: '0',
  },
  {
    name: 'Feb',
    value: '1',
  },
  {
    name: 'Mar',
    value: '2',
  },
  {
    name: 'Apr',
    value: '3',
  },
  {
    name: 'May',
    value: '4',
  },
  {
    name: 'Jun',
    value: '5',
  },
  {
    name: 'Jul',
    value: '6',
  },
  {
    name: 'Aug',
    value: '7',
  },
  {
    name: 'Sep',
    value: '8',
  },
  {
    name: 'Oct',
    value: '9',
  },
  {
    name: 'Nov',
    value: '10',
  },
  {
    name: 'Dec',
    value: '11',
  },
];

export const GROSS_INCOME_NAME =
  'credit.employment_details.gross_annual_income.amount';
